import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { getUserDetails } from '../utils/LocalStorage'
import HeaderEmployer from '../commonComponents/HeaderEmployer'
import HeaderRecruiter from '../commonComponents/HeaderRecruiter'
import { paddingHorizontal, paddingVertical } from '../utils/AppConstants'

import { useTheme } from '@mui/material/styles'
import WebSocketManager from '../api/WebSocketManager.js'
import { useMediaQuery } from '@mui/material'
import BottomNavBar from '../commonComponents/BottomNavBar.js'

const ProtectedRoutes = ({
  role,
  isNotAllowedToSubEmployer,
  component: Component,
  componentStyle = {}
}) => {
  var user = getUserDetails()
  var theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm')) // Detect small screens

  useEffect(() => {
    if (user && user.usertype === 'recruiter') {
      WebSocketManager.init()

      return () => {
        console.log('Websocket Close in protected route')
        WebSocketManager.socket.close()
      }
    }
  }, [])

  if (!user) {
    return <Navigate to={'/login'} />
  } else if (
    user.usertype === role &&
    !(isNotAllowedToSubEmployer && user.isSubEmployer)
  ) {
    return (
      <div style={{ height: '100vh', overflow: 'hidden' }}>
        <div
          style={{
            height: matches ? '56px' : '60px'
          }}
        >
          {user.usertype === 'employer' && <HeaderEmployer user={user} />}
          {user.usertype === 'recruiter' && <HeaderRecruiter user={user} />}
        </div>
        <div
          style={{
            height: `calc(100% - 110px)`,
            overflow: 'auto',
            padding: matches
              ? '30px'
              : `${paddingVertical} ${paddingHorizontal}`,
            ...componentStyle
          }}
        >
          {typeof Component === 'object' ? (
            Component
          ) : (
            <Component user={user} />
          )}
        </div>
        {matches && user.usertype === 'recruiter' && <BottomNavBar />}
      </div>
    )
  } else {
    return <Navigate replace to={`/${user?.usertype}/dashboard`} />
  }
}

export default ProtectedRoutes
